export default __webpack_public_path__ + "static/media/articleQ.313d83ab.jpg";